import { motion } from "framer-motion";

export default function Education() {
  return (
    <motion.section
      id="education"
      className="min-h-screen px-6 py-20 bg-white dark:bg-gray-900 text-gray-800 dark:text-white"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <h2 className="text-5xl font-heading font-bold mb-6 border-b-4 border-blue-600 inline-block">
        Education
      </h2>

      <div className="space-y-12">
        {/* WGU */}
        <div className="relative">
          <div className="flex justify-between items-start mb-1">
            <h3 className="text-2xl font-semibold text-blue-700 dark:text-blue-300">
              Western Governors University, Millcreek, UT
            </h3>
            <p className="text-base text-gray-700 dark:text-gray-200">Dec 2026</p>
          </div>
          <p className="text-base text-gray-800 dark:text-gray-100 mb-3">
            Bachelor of Science in Computer Science
          </p>
          <ul className="list-disc list-inside text-lg leading-relaxed text-gray-700 dark:text-gray-300 space-y-1">
            <li>Focused on cloud computing, DevOps, data structures, and systems programming.</li>
            <li>Hands-on experience with containers, Linux, and infrastructure-as-code projects.</li>
          </ul>
        </div>

        {/* UHart */}
        <div className="relative">
          <div className="flex justify-between items-start mb-1">
            <h3 className="text-2xl font-semibold text-blue-700 dark:text-blue-300">
              University of Hartford, West Hartford, CT
            </h3>
            <p className="text-base text-gray-700 dark:text-gray-200">May 2021</p>
          </div>
          <p className="text-base text-gray-800 dark:text-gray-100 mb-3">
            Bachelor of Science in Biology
          </p>
          <ul className="list-disc list-inside text-lg leading-relaxed text-gray-700 dark:text-gray-300 space-y-1">
            <li>Strong foundation in data analysis, research methodology, and scientific writing.</li>
            <li>Developed transferable skills valuable in IT systems analysis and troubleshooting.</li>
          </ul>
        </div>
      </div>
    </motion.section>
  );
}
